import React, { useMemo } from 'react'
import styled from 'styled-components'
import stampAutoDir from '@Utilities/StampAutoDir'
import { sanitizeStudentHtml } from './sanitizeStudentHtml'

type Props = {
	/** Stored answer: always HTML (the API normalises every text answer on write). */
	value: string | null | undefined
	className?: string
}

/**
 * Read-only render of the student's own text answer (test summary, submitted
 * assignment). Sanitized with the student allowlist and dir-stamped. Quill's
 * class attributors are styled by the globally mounted QuillContentStyles.
 */
const StudentAnswerHtml: React.FC<Props> = ({ value, className }) => {
	const html = useMemo(() => stampAutoDir(sanitizeStudentHtml(value)), [value])
	// No `ql-editor` class: Quill's editor stylesheet (loaded with the lazy
	// editor chunk) forces text-align:left on it, which would flip Arabic
	// answers depending on navigation history. The unscoped `ql-*` rules in
	// QuillContentStyles already style alignment/indent classes.
	return <Body className={className} dangerouslySetInnerHTML={{ __html: html }} />
}

const Body = styled.div`
	white-space: pre-wrap;
	overflow-wrap: anywhere;
	text-align: start;
`

export default StudentAnswerHtml
